<div *ngIf="order$ | async as order"
     class="mb-submit-order-wrapper"
     data-cy="mb-submit-order-wrapper">

  <mb-submit-order-request *ngIf="!isPurchaseCheckout"
                           [requestItemsNo]="getTotalQuantityOfTypeOfItems(constants.PRICE_REQUEST, order)"
                           [purchaseItemsNo]="getTotalQuantityOfTypeOfItems(constants.PRICE_MIX, order)"
                           [totalPrice]="order.totalPrice">
  </mb-submit-order-request>

  <mb-submit-order-price *ngIf="isPurchaseCheckout"
                         [purchaseItemsNo]="getTotalQuantityOfTypeOfItems(constants.PRICE_AVAILABLE, order)"
                         [requestItemsNo]="getTotalQuantityOfTypeOfItems(constants.PRICE_REQUEST, order)"
                         [totalPrice]="order.totalPrice"
                         [showShippingTaxes]="true"
                         [prices]="order"
                         [shouldDisplayErpPrices]="true">
  </mb-submit-order-price>

  <div class="row no-gutters mt-2 pt-3 mb-submit-order-totals"
       data-cy="mb-submit-order-totals">

    <ng-container *ngIf="isPurchaseCheckout">
      <div class="col-4"
           data-cy="mb-submit-order-title">
        {{'submitBox.orderTotal' | cxTranslate}}
      </div>

      <div class="col-8 text-right"
           data-cy="mb-submit-order-price">
        <span *ngIf="!order?.erpPricingError; else pricingError">
          <ng-container *ngIf="order?.erpTotalPrice; else customCart">
            <strong [innerHTML]="order?.erpTotalPrice?.formattedValue | safeHtml"></strong>
          </ng-container>
          <ng-template #customCart>
            <strong [innerHTML]="order?.erpTotalListPrice?.formattedValue | safeHtml"></strong>
          </ng-template>
        </span>
        <ng-template #pricingError>
          <span>{{'submitBox.orderConfirmation' | cxTranslate}}</span>
        </ng-template>
      </div>

      <div *ngIf="order?.erpPricingError"
           class="col-12 my-3 mb-request-info">
        <span>{{'submitBox.orderConfirmationEmail' | cxTranslate}}</span>
      </div>
    </ng-container>

    <ng-container *ngIf="!isPurchaseCheckout">
      <div class="col-12 mb-request-info"
           data-cy="mb-submit-order-step-info">{{'submitBox.requestInfo' | cxTranslate}}
      </div>
    </ng-container>

  </div>
</div>
